import React from 'react';
import { Navigate, Outlet } from 'react-router';
import ErrorBoundary from '../../ErrorBoundary';
import { AppContext } from '../../App';
import { useAuth0 } from '@auth0/auth0-react';

import WelcomePage from '../../pages/WelcomePage';
import TopBar from '../common/TopBar';
import Maintenance from '../common/Maintenance';
import { useLocation } from 'react-router';
import OrgPage from '../../pages/OrgPage';
import SelectDefaultsPage from '../../pages/SelectDefaultsPage';

const PrivateRoute = (isAllowed?: any, children?: React.ReactElement) => {
  const { dataPoolId, maintenance, isStaff } = React.useContext(AppContext);
  const { isAuthenticated } = useAuth0();

  const location = useLocation();
  const path = location.pathname;

  if (!isAllowed) {
    return <Navigate to={'/'} replace />;
  }

  if (isAuthenticated === true) {
    if (maintenance) {
      return (
        <div>
          <TopBar />
          <Maintenance />
        </div>
      );
    }

    if (path === '/vendors' || path === '/vendors/') {
      return (
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      );
    } else if (dataPoolId || path === '/organization/' || path.match(/data-pools/)) {
      return (
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      );
    } else if (isStaff) {
      return (
        <ErrorBoundary>
          <OrgPage />
        </ErrorBoundary>
      );
    } else {
      return <SelectDefaultsPage />;
    }
  } else {
    return <WelcomePage />;
  }
};
export default PrivateRoute;
